export const GROUP_MEMBERSHIPS = {
  users: {
    linkedReference: 'vehicle-groups',
    linkedGroupSource: 'vehicle_group_ids',
    memberSource: 'vehicle_ids',
    memberCountKey: 'mymove.accessGroups.vehicleCount',
    memberCountVariable: 'vehicles',
  },
  vehicles: {
    linkedReference: 'user-groups',
    linkedGroupSource: 'user_group_ids',
    memberSource: 'user_ids',
    memberCountKey: 'mymove.accessGroups.userCount',
    memberCountVariable: 'users',
  },
}
